/** Format a leaf value for the ServiceNow details table. */
function formatLeaf(raw: unknown): string {
  if (raw === null || raw === undefined) {
    return '';
  }
  if (typeof raw === 'string') {
    return raw;
  }
  if (typeof raw === 'number' || typeof raw === 'boolean') {
    return String(raw);
  }
  try {
    return JSON.stringify(raw);
  } catch {
    return String(raw);
  }
}

/**
 * Flatten Firestore `service_now` into display rows.
 * Nested maps become dotted keys (e.g. catalog_task.number).
 */
export function serviceNowEntries(
  serviceNow: Record<string, unknown> | undefined,
): Array<{ key: string; value: string }> {
  if (
    !serviceNow ||
    typeof serviceNow !== 'object' ||
    Array.isArray(serviceNow)
  ) {
    return [];
  }

  const rows: Array<{ key: string; value: string }> = [];

  function walk(obj: Record<string, unknown>, prefix: string) {
    for (const [key, raw] of Object.entries(obj)) {
      const path = prefix ? `${prefix}.${key}` : key;
      if (raw !== null && typeof raw === 'object' && !Array.isArray(raw)) {
        walk(raw as Record<string, unknown>, path);
      } else {
        rows.push({ key: path, value: formatLeaf(raw) });
      }
    }
  }

  walk(serviceNow, '');
  return rows;
}
